// Credit Management Constants

// Button Text Constants
export const CREDIT_BUTTONS = {
  APPLY: 'Apply',
  ASSIGN: 'Assign',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
  CONFIRM_SWITCH: 'Confirm Switch',
  TRY_AGAIN: 'Try again',
  CLOSE: 'Close',
  TRACK_MANUALLY_OFMP: 'Track manually by OFMP',
  SWITCH_TO_MANUAL: 'Switch to manual tracking'
} as const;

// Labels and Headers
export const CREDIT_LABELS = {
  COMPANY_UNIQUE_ID: 'Company Unique Identifier',
  MDM_ID: 'MDM ID',
  CREDIT_CHECK: 'Credit check',
  CREDIT_LIMIT: 'Credit limit',
  UTILIZATION: 'Utilization',
  AVAILABLE: 'Available',
  COMPANY_NAME: 'Company name',
  ADDRESS: 'Address',
  ACCOUNT_TYPE: 'Account type',
  CREDIT_DATA: 'Credit data',
  ID_STATUS: 'ID status'
} as const;

// Status Messages
export const CREDIT_STATUS_MESSAGES = {
  TRACKED_BY_OFMP: 'Tracked by OFMP',
  READING_FROM_SOURCE: 'Reading from your source system',
  SOURCE_CONNECTED: 'Your source system connected',
  SOURCE_OFFLINE: 'Your source system is offline',
  SOURCE_FAILED: 'Read from your source system failed',
  UID_REQUIRED: 'Setup is required',
  NOT_AVAILABLE: 'n/a'
} as const;

// Placeholder Text
export const CREDIT_PLACEHOLDERS = {
  ENTER_NUMBER: 'Enter number',
  ENTER_AMOUNT: 'Enter amount'
} as const;

// Error Messages
export const CREDIT_ERROR_MESSAGES = {
  MDM_INCORRECT: 'MDM number is incorrect or external system could not be found.',
  ID_REQUIRED: 'ID is required',
  NON_ZERO_REQUIRED: 'Cannot be zero',
  API_NOT_FOUND: 'API not found',
  SERVICE_UNAVAILABLE: 'Service unavailable',
  FAILED_TO_ASSIGN: 'Failed to assign MDM ID',
  FAILED_TO_UPDATE: 'Failed to update credit limit',
  FAILED_TO_SWITCH: 'Failed to switch to OFMP tracking',
  CREDIT_LIMIT: 'Credit limit must be greater than 0 and cannot exceed 999,000,000'
} as const;

// Success Messages
export const CREDIT_SUCCESS_MESSAGES = {
  MDM_ASSIGNED: 'MDM ID assigned successfully',
  CREDIT_UPDATED: 'Credit limit updated successfully',
  SWITCHED_TO_OFMP: 'Successfully switched to OFMP tracking',
  CREDIT_CHECK_ENABLED: 'Company\'s ID assigned. Credit check enabled'
} as const;

// Modal Titles
export const CREDIT_MODAL_TITLES = {
  ASSIGNING_MDM: 'Assigning MDM ID',
  INACTIVE_ID: 'Inactive ID can not be assigned',
  MDM_NOT_EXIST: 'MDM ID does not exist',
  UNABLE_TO_CONNECT: 'Unable to connect to source system',
  SWITCH_TO_OFMP: 'Track manually by OFMP'
} as const;

// Description Text
export const CREDIT_DESCRIPTIONS = {
  MDM_DESCRIPTION: 'Please provide your company\'s MDM number (ERP system ID), or leave this field blank to track the order manually via the OFMP system.',
  CREDIT_CHECK_DESCRIPTION: 'Credit check will be performed on each Purchase Order placement',
  EXTERNAL_SYSEM_INACTIVE: 'External credit system error',
  EXTERNAL_SYSEM_INACTIVE_DESCRIPTION: 'Your external credit system (ERP) is offline. Please click on “Credit Settings” in order to switch to Manual OFMP credit management system, or recheck credit to try again.',
  SETUP_REQUIRED: 'Setup required.',
  AUTOMATION_FOUND_NO_CREDIT: 'Automation found no credit',
  AUTOMATION_FOUND_INSUFFICIENT_CREDIT: 'Automation found insufficient credit'
} as const;

// API Response Keys
export const CREDIT_API_KEYS = {
  SUCCESS: 'success',
  MESSAGE: 'message',
  DATA: 'data',
  CREDIT: 'credit'
} as const;

// Default Values
export const CREDIT_DEFAULTS = {
  INITIAL_AMOUNT: 0,
  RESERVED_AMOUNT: 0,
  USED_AMOUNT: 0,
  ALLOW_NEGATIVE: false
} as const;

export const CREDIT_SOURCES = {
  MDM: 'MDM',
  INTERNAL: 'INTERNAL'
}

export const CREDIT_SOURCE_ACTIVITY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

// Credit Check Status Constants
export const CREDIT_CHECK_STATUSES = {
  PASSED: 'Passed',
  OVERRIDE: 'Override', 
  FAILED: 'Failed',
  REJECTED: 'Rejected',
  NOT_AVAILABLE: 'Not available',
  UNKNOWN: 'Unknown'
} as const;

// Message Constants
export const CREDIT_MESSAGES = {
  ERROR_FETCHING_DETAILS: 'Error fetching vendor company details. Please try again later.',
  CREDIT_LIMIT_UPDATED: 'Credit limit for {companyName} was updated',
  MDM_ID_ASSIGNED: 'Company\'s ID assigned. Credit check enabled',
  CREDIT_RECORD_UPDATED: 'Credit record updated successfully',
  CREDIT_RECORD_CREATED: 'Credit record created successfully',
  SWITCH_TO_OFMP_CONFIRMATION: 'Are you sure you want to Track manually by OFMP? All credit transactions need to be managed manually. Sales order will not be created automatically.'
};

// Business Unit Relations Tab Constants
export const BUSINESS_UNIT_RELATIONS = {
  MODAL_TITLE: 'Switch to business unit view',
  MODAL_BUTTON_TEXT: 'Switch',
  MODAL_MESSAGE_PREFIX: 'You have to switch from Admin to',
  MODAL_MESSAGE_SUFFIX: 'view to be able to see or edit Business Unit / Company relations.',
  NOT_ASSIGNED: 'Not assigned',
  PLEASE_SELECT_BUSINESS_UNIT: 'Please select a business unit.',
  PLEASE_SELECT_VENDOR: 'Please select a vendor.'
} as const;

// Business Unit Section Constants
export const BUSINESS_UNIT_SECTION = {
  TITLE: 'Business Unit',
  DESCRIPTION: 'When a Business Unit is selected and assigned to a company, all website users associated with that company will gain visibility of the products sold under that Business Unit. These products will be accessible in My Account → My Products. This feature is enabled for customers who have an active subscription.',
  BUTTON_APPLY: 'Apply',
  BUTTON_REMOVE: 'Remove',
  MODAL_TITLE: 'Remove Business Unit',
  MODAL_DESCRIPTION: 'This Business unit has an active subscription. If you change this relation, it will be applied to subscription as well.',
  MODAL_BUTTON_CONFIRM: 'Apply',
  MODAL_BUTTON_CANCEL: 'Cancel'
} as const;
